import { pageViewTypes } from "@constants/tracking";
import { HomeRouteContainer } from "@features/dashboard/components/HomeRouteContainer";
import ImageChallengeHomeContainer from "@features/dashboard/containers/ImageChallengeHomeContainer";
import StudyPackContainer from "@features/dashboard/screens/StudyPackContainer";
import { ModulesContainer } from "@features/modules/containers/ModulesContainer";
import useAnalytics from "@hooks/useAnalytics";
/* -----------------Globals--------------- */
import { useAppStore } from "@hooks/useAppStore";
import { useAppTemplate } from "@hooks/useAppTemplate";
import DocumentTitle from "components/DocumentTitle";
import { useMemo } from "react";

/* -----------------Child components--------------- */

const StudyPackRouteContainer = () => {
	return (
		<>
			<DocumentTitle title="Study-Pack" />
			<StudyPackContainer />
		</>
	);
};
const HomeRoute = () => {
	const showStudyPackAsHome = useAppStore((store) => store.showStudyPackAsHome);

	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.home,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	const isImageChallengeApp = useAppStore(
		(store) => store.app.isImageChallengeApp,
	);
	const { isCmeApp } = useAppTemplate();

	if (isCmeApp) {
		return (
			<>
				<DocumentTitle title="Modules" />
				<ModulesContainer />
			</>
		);
	}

	if (isImageChallengeApp) {
		return <ImageChallengeHomeContainer />;
	}

	if (showStudyPackAsHome) {
		return <StudyPackRouteContainer />;
	}
	return (
		<>
			<DocumentTitle title="Home" />
			<HomeRouteContainer />
		</>
	);
};

export default HomeRoute;
